import React from 'react';
import { arrayOf, bool, func, node, object, shape, string } from 'prop-types';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import BlockBuilder from '../../BlockBuilder';

import SectionContainer from '../SectionContainer';
import css from './SectionArticle.module.css';
import SectionThree from '../SectionColumns/SectionThree';
import leftImage from './rightimage.png'
import leftImageNew from '../../../../assets/New Images/About-PricingTransparency.jpg'
import rightImageNew from '../../../../assets/New Images/About-PricingTransparency-2 (1).jpg'

import rightImage from './leftimage.png'

// Section component that's able to show article content
// The article content is mainly supposed to be inside a block
const SectionArticle = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    title,
    description,
    appearance,
    callToAction,
    blocks,
    isInsideContainer,
    options,
    isLandingPage,
    isTOSorPPpage,
  } = props;
  console.log(isLandingPage, 'islandingPage');
  console.log("sectionId-obais--",sectionId)
  console.log(isTOSorPPpage, 'isTOSorPPpage');
  // console.log(blocks[0].blockName, 'blocks');
  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);
  const hasBlocks = blocks?.length > 0;

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      {isTOSorPPpage ? (
        <div
          className={classNames(defaultClasses.blockContainer, css.articleMain, {
            [css.noSidePaddings]: isInsideContainer,
          })}
        >
          <BlockBuilder
            blocks={blocks}
            sectionId={sectionId}
            ctaButtonClass={defaultClasses.ctaButton}
            options={options}
            className={css.tosppBlock}
          />
        </div>
      ) : null}
      {isLandingPage && sectionId === 'section-2' ? <SectionThree /> : null}

      {isLandingPage && sectionId === 'section-6' ? (
        <div className={css.sectionSixParent}>
        <img src={leftImageNew} className={css.rightLeftImages} />
        <div className={css.sectionSix}>
          <header className={css.sectionSixDetails}>
            <Field data={title} className={defaultClasses.title} options={fieldOptions} />
            <Field
              data={description}
              className={css.sectionSixDescription}
              options={fieldOptions}
            />
            <Field
              data={callToAction}
              className={defaultClasses.ctaButton}
              options={fieldOptions}
            />
          </header>
          <div
            className={classNames(css.blockContainerSectionSix, css.articleMainSectionSix, {
              [css.noSidePaddings]: isInsideContainer,
            })}
          >
            <BlockBuilder
              className={css.sectionSixBlocks}
              blocks={blocks}
              sectionId={sectionId}
              ctaButtonClass={defaultClasses.ctaButton}
              options={options}
            />
          </div>
        </div>
           <img src={rightImageNew} className={css.rightLeftImages} />
           </div>
      ) : null}

      {!isLandingPage && hasHeaderFields ? (
        <header className={defaultClasses.sectionDetails}>
          <Field data={title} className={defaultClasses.title} options={fieldOptions} />
          <Field data={description} className={defaultClasses.description} options={fieldOptions} />
          <Field data={callToAction} className={defaultClasses.ctaButton} options={fieldOptions} />
        </header>
      ) : null}
      {!isLandingPage &&!isTOSorPPpage  && hasBlocks ? (
        <div
          className={classNames(defaultClasses.blockContainer, css.articleMain, {
            [css.noSidePaddings]: isInsideContainer,
          })}
        >
          <BlockBuilder
            blocks={blocks}
            sectionId={sectionId}
            ctaButtonClass={defaultClasses.ctaButton}
            options={options}
          />
        </div>
      ) : null}
    </SectionContainer>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

SectionArticle.defaultProps = {
  className: null,
  rootClassName: null,
  defaultClasses: null,
  textClassName: null,
  title: null,
  description: null,
  appearance: null,
  callToAction: null,
  blocks: [],
  isInsideContainer: false,
  options: null,
};

SectionArticle.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
  defaultClasses: shape({
    sectionDetails: string,
    title: string,
    description: string,
    ctaButton: string,
  }),
  title: object,
  description: object,
  appearance: object,
  callToAction: object,
  blocks: arrayOf(object),
  isInsideContainer: bool,
  options: propTypeOption,
};

export default SectionArticle;
